import { useTranslate } from "@refinedev/core";
import { camelCase, last, startCase, words } from "lodash-es";
import type { UseTranslationOptions } from "react-i18next";

export const useTranslation = (
  ns: string,
  options?: UseTranslationOptions<string>
) => {
  const translate = useTranslate();
  const prefix = options?.keyPrefix;

  const t = (
    key: string,
    options: Record<string, any> = { ns },
    defaultVal: string = startCase(camelCase(last(words(key))))
  ) => {
    options.ns = ns;
    const realKey = prefix ? `${prefix}.${key}` : key;
    return translate(realKey, options, defaultVal);
  };

  const fieldT = (
    key: string,
    options: Record<string, any> = { ns },
    defaultVal?: string
  ) => {
    options.ns = ns;
    const realKey = prefix ? `${prefix}.fields.${key}` : `fields.${key}`;
    return translate(realKey, options, defaultVal);
  };

  const actionT = (
    key: string,
    options: Record<string, any> = { ns },
    defaultVal?: string
  ) => {
    options.ns = ns;
    const realKey = prefix ? `${prefix}.actions.${key}` : `actions.${key}`;
    return translate(realKey, options, defaultVal);
  };

  const titleT = (
    key: string,
    options: Record<string, any> = { ns },
    defaultVal?: string
  ) => {
    options.ns = ns;
    const realKey = prefix ? `${prefix}.titles.${key}` : `titles.${key}`;
    return translate(realKey, options, defaultVal);
  };

  return { t, fieldT, actionT, titleT };
};

/**
 * @deprecated
 * @param resourceName
 * @returns
 */
export const useFieldTranslate = (resourceName: string) => {
  const translate = useTranslate();

  return (key: string, defaultVal = startCase(camelCase(key))) => {
    return translate(resourceName + ".fields." + key, defaultVal);
  };
};

export const useActionTranslate = (resourceName: string) => {
  const translate = useTranslate();

  return (key: string, defaultVal?: string) => {
    return translate(resourceName + ".actions." + key, defaultVal);
  };
};

/**
 * @deprecated
 * @param resourceName
 * @returns
 */
export const useTitleTranslate = (resourceName: string) => {
  const translate = useTranslate();

  return (
    key: string,
    options: any = startCase(camelCase(key)),
    defaultVal = startCase(camelCase(key))
  ) => {
    return translate(resourceName + ".titles." + key, options, defaultVal);
  };
};

/**
 * @deprecated
 * @returns
 */
export const useButtonTranslate = () => {
  const translate = useTranslate();

  return (key: string, options?: any, defaultVal?: string) => {
    return translate("buttons." + key, options, defaultVal);
  };
};

/**
 * @deprecated
 * @returns
 */
export const useFormTranslate = () => {
  const translate = useTranslate();

  return (key: string, options?: any, defaultVal?: string) => {
    return translate("forms." + key, options, defaultVal);
  };
};
